import StudentGradebookEntry from 'models/StudentGradebookEntry';
import React from 'react';
import contentService from 'services/contentService';
import { formatDate } from 'utils/utils';
import { AudioAssistanceButton } from 'view/components/buttons/AudioAssistanceButton';

interface AssignmentDetailsProps {
  entry: StudentGradebookEntry;
}

const AssignmentDetails: React.FC<AssignmentDetailsProps> = ({ entry }) => {
  const pageContent = contentService.getStudentClassroomPage();

  return (
    <div className="sidebar-content-data">
      <div className="assignment-details-container">
        <div className="assignment-detail-header">
          <label className="label-small">
            {pageContent.sidebar.assignment_preview.title}
          </label>
          <AudioAssistanceButton text="Selected Assignment" />
        </div>
        <div className="assignment-details-list">
          <div className="assignment-detail">
            <label className="label-small">
              {pageContent.sidebar.assignment_preview.attributes[0].label}
            </label>
            <label className="label-small">{entry.submission.grade}%</label>
          </div>
          <div className="assignment-detail">
            <label className="label-small">
              {pageContent.sidebar.assignment_preview.attributes[1].label}
            </label>
            <label className="label-small">
              {entry.submission.completion_score}%
            </label>
          </div>
          <div className="assignment-detail">
            <label className="label-small">
              {pageContent.sidebar.assignment_preview.attributes[2].label}
            </label>
            <label className="label-small">
              {entry.assignment.due_date
                ? formatDate(new Date(entry.assignment.due_date))
                : 'No due date'}
            </label>
          </div>
          <div className="assignment-detail">
            <label className="label-small">
              {pageContent.sidebar.assignment_preview.attributes[3].label}
            </label>
            <label className="label-small">
              {entry.assignment.start_date
                ? formatDate(new Date(entry.assignment.start_date))
                : 'Any time'}
            </label>
          </div>
          <div className="assignment-detail">
            <label className="label-small">
              {pageContent.sidebar.assignment_preview.attributes[4].label}
            </label>
            <label className="label-small">
              {entry.submission.questions_answered}/
              {entry.assignment.num_questions}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignmentDetails;
